module.exports = __webpack_public_path__ + "img/user_avatar.4820dfd8.webp";